import { Link } from '@startuptools/ui/Link';

export const SnrFilingLink = ({ filingNumber, filingYear }: { filingNumber: string; filingYear: string }) => {
  const url = `https://sokarende.bolagsverket.se/mia/visaarende.xhtml?artal=${filingYear}&id=${filingNumber}`;

  return (
    <Link href={url} target="_blank">
      {filingNumber}/{filingYear}
    </Link>
  );
};
